import { render, staticRenderFns } from "./referenzen-software-3.vue?vue&type=template&id=5cb49976&"
import script from "./referenzen-software-3.vue?vue&type=script&lang=js&"
export * from "./referenzen-software-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports